import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import styles from '~/components/SecureLoginModal/SecureLoginModal.module.scss';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
export const LoginErrorModal = ()=>{
    const overlayContext = useOverlayContext();
    const history = useHistory();
    const location = useLocation();
    useEffect(()=>{
        const baseRoute = location.pathname.replace(routes.loginError, '');
        let updatedDismissModal;
        overlayContext.showModal({
            biName: 'actual_login_error_modal',
            content: (param)=>{
                let { dismissModal } = param;
                updatedDismissModal = dismissModal;
                return /*#__PURE__*/ _jsx(ActualLoginErrorModal, {
                    dismissModal: updatedDismissModal
                });
            },
            closeOnClickOutside: true,
            closeOnEscapeKey: true
        }).then(()=>{
            history.replace(baseRoute);
        });
        return ()=>{
            if (updatedDismissModal) {
                updatedDismissModal(false);
            }
        };
    }, []);
    return null;
};
export const ActualLoginErrorModal = (param)=>{
    let { dismissModal } = param;
    const { t: loginErrorModalTexts } = useLocaleKeys('components.loginErrorModal');
    const { t: commonTexts } = useLocaleKeys('common');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'login_error_confirm'
            },
            secondaryButton: {
                name: 'login_error_cancel'
            }
        },
        testId: "login-error-modal",
        title: loginErrorModalTexts.title(),
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.secureLoginModalContainer,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: loginErrorModalTexts.differentEmail()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: loginErrorModalTexts.secureLoginMessage()
                }),
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx(Typography, {
                    children: loginErrorModalTexts.openAccount()
                })
            ]
        }),
        onCloseButtonClick: ()=>dismissModal(false),
        primaryButtonLabel: "",
        onPrimaryButtonClick: ()=>dismissModal(true),
        secondaryButtonLabel: commonTexts.buttons.back(),
        onSecondaryButtonClick: ()=>dismissModal(false)
    });
};
